import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';
import SEO from '../components/SEO';
import './ThankYou.css';

const ThankYou = () => {
  const [countdown, setCountdown] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="thank-you-page">
      <SEO 
        title="Thank You - HEGXIB Nigeria"
        description="Thank you for contacting HEGXIB Nigeria. We've received your message and will get back to you shortly."
        url="https://ng.hegxib.me/thank-you"
      />
      <motion.div 
        className="thank-you-content"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="thank-you-logo"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.5 }}
        >
          <img 
            src="/assets/HXB-NG-NO-BACKGROUND.png" 
            alt="HEGXIB Nigeria" 
          />
        </motion.div>

        <motion.div
          className="success-icon"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
        >
          <FaCheckCircle />
        </motion.div>

        <motion.h1
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          Thank You!
        </motion.h1>

        <motion.p
          className="thank-you-message"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          Your message has been sent successfully. We'll get back to you as soon as possible.
        </motion.p>

        <motion.div
          className="countdown-wrapper"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <div className="countdown-circle">
            <svg className="countdown-svg" viewBox="0 0 100 100">
              <circle
                className="countdown-bg"
                cx="50"
                cy="50"
                r="45"
              />
              <motion.circle
                className="countdown-progress"
                cx="50"
                cy="50"
                r="45"
                initial={{ pathLength: 1 }}
                animate={{ pathLength: 0 }}
                transition={{ duration: 10, ease: 'linear' }}
                style={{
                  strokeDasharray: 283,
                  strokeDashoffset: 283 * (countdown / 10)
                }}
              />
            </svg>
            <div className="countdown-number">{countdown}</div>
          </div>
          <p className="countdown-text">Redirecting to homepage...</p>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          <button
            className="btn btn-primary"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            Go to Homepage Now
          </button>
        </motion.div>


      </motion.div>

      {/* Animated background */}
      <div className="thank-you-bg">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
      </div>
    </div>
  );
};

export default ThankYou;
